import { ArticleOffer } from "../components/article-offer";

const test = ({ __typename, offer }: { __typename: string, offer: any }): boolean => {
    if (!offer) return false; 
    return __typename === "VinoData_ArticleOffer";
}
const create = (data): JSX.Element => {
  return <ArticleOffer {...data} />;
};

export default { test, create };
